// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuAnnouncement_wrapper__gqP5y","line":"MenuAnnouncement_line___yyoh","winWithFriends":"MenuAnnouncement_winWithFriends__u6oCc"};